import {useCallback} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import {commonFiltersValue} from "@signals";
import {
	adminProductReviewDetailsData,
	adminProductReviewItemsData,
	adminProductReviewTableData,
	retailerSelected,
	filteredRetailers,
	adminProductReviewHeaderTableData
} from "../@signals";


export default function useAdminProductReviewSubmits() {
	const { showToast } = useToast()
	const AdminProductReviewIsEmpty = useSignal(false)
	
	const handleSubmitFilters = useCallback(values => {
		AdminProductReviewIsEmpty.value = false
		adminProductReviewItemsData.value = []
		
		return postSubmit(`${BACKEND_APIS.ADMIN}/product-review/raw-data`, values).then(({ table, detail, header }) => {
			if (!table.length) AdminProductReviewIsEmpty.value = true
			else {
				adminProductReviewTableData.value = table
				adminProductReviewDetailsData.value = detail
				adminProductReviewHeaderTableData.value = header
				filteredRetailers.value = commonFiltersValue.value.retailer
				retailerSelected.value = commonFiltersValue.value.retailer
			}
		}).catch(() => {
			showToast.error()
		})
	}, [])

	return {
		AdminProductReviewIsEmpty,

		handleSubmitFilters
	}
}